import axios from 'axios'
// import qs from 'qs'

let appConfig = require('../../../config/index.js')
let axiosInstance
let typeOf = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
  return typeof obj
} : function (obj) {
  return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
}

// 封装请求
class MyRequest {
  constructor () {
    // 创建axios实例
    // application/json   application/x-www-form-urlencoded
    axiosInstance = axios.create({
      baseURL: appConfig.API_URL,
      timeout: 90000,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    // 添加请求拦截器
    axiosInstance.interceptors.request.use(function (config) {
      // open_id 用户在不同平台上对应的唯一值
      let openId = global.myStore.get(global.myStore.staticName.ACCESS_OPENID)
      if (config.data && !config.data.hasOwnProperty('openid') && openId) {
        config.data['openid'] = openId
      }
      // 用户信息
      let userInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
      if (config.data && !config.data.hasOwnProperty('member_no') && userInfo && userInfo.member_no) {
        config.data['member_no'] = userInfo.member_no
      }
      if (config.method === 'get' && config.data) {
        config.params = config.data
      }
      return config
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error)
    })

    // 添加响应拦截器
    axiosInstance.interceptors.response.use((response) => {
      // console.log(response)
      // 对响应数据做点什么
      if (!response || !response.data) {
        return Promise.reject(response)
      } else if (response.data.status !== '200') {
        // 处理所有的错误
        // 864 表示不存在的用户， 869 表示用户被冻结
        if (response.data.status === '864') {
          global.myStore.remove(global.myStore.staticName.USER_INFO)
          // 不存的用户进入绑定手机页面
          return Promise.reject(response.data)
        }

        if (response.data.msg) {
          global.app.$vux.toast.text(response.data.msg, 'middle')
        } else {
          global.app.$vux.toast.text('请求出错了,请稍后再次尝试', 'middle')
        }
        return Promise.reject(response.data)
      }
      return response.data
    }, function (error) {
      console.log('error: ', error)
      // global.app.$vux.toast.text('请求出错了,请稍后再次尝试', 'middle')
      // 对响应错误做点什么
      return Promise.reject(error)
    })
  }

  // 是否是对象
  isObject (obj) {
    return (typeof obj === 'undefined' ? 'undefined' : typeOf(obj)) === 'object' && obj !== null
  }

  // 继承扩展
  extend (obj) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key]
    }
    if (this.isObject(obj) && args.length > 0) {
      if (Object.assign) {
        return Object.assign.apply(Object, [obj].concat(args))
      }
      args.forEach(function (arg) {
        if (this.isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            obj[key] = arg[key]
          })
        }
      })
    }
    return obj
  }

  sendRrquest (url, method, data, header, baseURL) {
    let obj = {
      method: method,
      url: url,
      data: data,
      headers: header
    }
    baseURL && (obj.baseURL = baseURL)
    return axiosInstance(obj)
  }
}

let myRequest = new MyRequest()

// 出请求
let MyHttp = function (defaultParams, ALL_API) {
  let resource = {}
  for (let actionName in ALL_API) {
    let _config = ALL_API[actionName]
    resource[actionName] = (pdata, pathParam) => {
      let paramsData = myRequest.extend({}, defaultParams, pdata)
      let url = _config.url
      let baseURL = _config.baseURL
      if (pathParam) {
        url = url + pathParam
      }
      return myRequest.sendRrquest(url, _config.method, paramsData, {
        // 'Content-Type': 'application/json'
        'Content-Type': 'application/json'
      }, baseURL)
    }
  }
  return resource
}

export default MyHttp



// WEBPACK FOOTER //
// ./src/utils/tools/request/request.js